import { render, staticRenderFns } from "./_companyDetailsModal.vue?vue&type=template&id=0fcd0480"
import script from "./_companyDetailsModal.vue?vue&type=script&lang=js"
export * from "./_companyDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports